module.exports = __webpack_public_path__ + "static/media/temp_44.d513b3cb.jpg";